import Seo from 'common/components/seo.component';
import { APP_NAME, APP_URL } from 'config/constants/api.constants';
import { RouteName } from 'config/constants/route.constants';
import { UserTranscription } from 'config/constants/transcription.constant';
import { SeoOpenGraphType } from 'config/types/common.type';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/index';
import MyProfileContainer from 'user/containers/my-profile.container';

const MyProfile: React.FC = () => {
  const { user } = useSelector((state: RootState) => state);

  const openGraphTags: SeoOpenGraphType[] = [
    { property: 'title', content: UserTranscription.USER_MY_PROFILE },
    { property: 'url', content: `${APP_URL}${RouteName.MY_PROFILE}` },
    { property: 'site_name', content: APP_NAME },
    { property: 'description', content: `EL perfil de ${user.userProfile.name || user.userProfile.email} en ${APP_NAME}` },
  ];

  return (
    <React.Fragment>
      <Seo title={UserTranscription.USER_MY_PROFILE} openGraphTags={openGraphTags} />
      <MyProfileContainer user={user} />
    </React.Fragment>
  );
};

export default MyProfile;
